import * as React from 'react';
export const IcRaspberry = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 14.5a3 3 0 00-2.08-2.84 3 3 0 00-3.62-3.57 3.001 3.001 0 00-4.6 0 3 3 0 00-3.62 3.57 3 3 0 000 5.68 3 3 0 003.62 3.57 3 3 0 004.6 0 3 3 0 003.62-3.57A3 3 0 0020 14.5zm-10-2a1 1 0 112 0 1 1 0 01-2 0zm2.71 5.71a1 1 0 11-1.409-1.42 1 1 0 011.409 1.42zM15 15.5a1 1 0 110-2.002 1 1 0 010 2.002zM12 6c2.31 0 3.3-2.24 3.49-3.42a.46.46 0 00-.11-.4A.46.46 0 0015 2a3.83 3.83 0 00-3 2 3.83 3.83 0 00-3-2 .46.46 0 00-.38.18.46.46 0 00-.11.4C8.7 3.76 9.69 6 12 6z'
      fill='currentColor'
    />
  </svg>
);
